export enum EventType {
  LOCALE_CHANGED = "localeChanged", // 语言变更
  DAYJS_LOCALE_LOADED = "dayjsLocaleLoaded", // dayjs 语言包加载完成事件
  ENABLE_WIDGET = "enableWidget", // 开启小部件事件
  CHECK_NOT_COMPLETED_TASK = "checkNotCompletedTask", // 检查未完成的步骤进行相应高亮
  FEE_WAVIER_CARD = "feeWavierCard", // 费用减免卡片高亮
  OPEN_EXPERT_INSTALL = "openExpertInstall", // 自动适配失败，打开专家安装弹窗
}

// 定义每个事件的回调参数类型
export interface EventPayloads {
  [EventType.LOCALE_CHANGED]: { locale: string }
  [EventType.DAYJS_LOCALE_LOADED]: { locale: string }
  [EventType.ENABLE_WIDGET]: { isEnable: boolean, cb: (result: boolean) => void }
  [EventType.CHECK_NOT_COMPLETED_TASK]: { checkTask: string }
  [EventType.OPEN_EXPERT_INSTALL]: void
}
